import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useProfileDropdown } from "@hooks/useProfileDropdown";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import ChangePasswordModal from "@features/ChangePassword/ChangePasswordModal";
import { useTranslation } from "react-i18next";
import ProfileModal from "@features/Profile/components";
import { UserModal } from "@components/common/Modal/UserModal";
import { LogoutConfirmationModal } from "@components/Auth";
import Button from "@components/common/Button/Button";

const ProfileDropdown = () => {
	const {
		showMenu,
		menuRef,
		handleToggle,
		handleLogout,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
		ShowProfile,
		HideProfile,
		showProfileModal,
		ShowChangePassword,
		HideChangePassword,
		showChangePasswordModal,
	} = useProfileDropdown();
	const { t } = useTranslation();

	const ExpandIcon = showMenu ? (
		<ExpandLessIcon className="text-gray-400" />
	) : (
		<ExpandMoreIcon className="text-gray-400" />
	);

	return (
		<div className="relative">
			<Button onClick={handleToggle} variant="icon">
				{ExpandIcon}
			</Button>
			{showMenu && (
				<div
					ref={menuRef}
					className="absolute right-0 z-50 mt-6 w-56 rounded-xl border border-gray-200 bg-white p-4 shadow-xl"
					role="menu"
					aria-label="Profile menu">
					<button
						type="button"
						className="profile-dropdown-item"
						role="menuitem"
						onClick={ShowProfile}>
						<PersonOutlineOutlinedIcon color="info" sx={{ fontSize: "24px" }} />
						{t("psdaCommon.profile.profileTitle")}
					</button>
					<button
						type="button"
						className="profile-dropdown-item"
						role="menuitem"
						onClick={ShowChangePassword}>
						<KeyOutlinedIcon color="info" sx={{ fontSize: "24px" }} />
						{t("psdaCommon.profile.changePassword.menuLabel")}
					</button>
					<div className="profile-dropdown-divider" role="separator" aria-orientation="horizontal" />
					<button
						type="button"
						className="profile-dropdown-item profile-dropdown-item--logout"
						onClick={handleLogout}
						role="menuitem">
						<LogoutOutlinedIcon color="error" sx={{ fontSize: "24px" }} />
						{t("psdaCommon.common.buttons.logout")}
					</button>
				</div>
			)}
			{showProfileModal && (
				<UserModal
					heigth={95}
					widthClass="w-full max-w-xl"
					show={showProfileModal}
					onClose={HideProfile}
					children={<ProfileModal HideProfile={HideProfile} />}
				/>
			)}
			<ChangePasswordModal isOpen={showChangePasswordModal} onClose={HideChangePassword} />
			<LogoutConfirmationModal show={showLogoutModal} onConfirm={handleLogoutConfirm} onCancel={handleLogoutCancel} />
		</div>
	);
};

export default ProfileDropdown;
